import services from '@/api/services';
import StoreConstructor from '@/store/core/StoreConstructor';
import { action, observable } from 'mobx';

export default class ExternalTaxPayersStore extends StoreConstructor {
  @observable isFetching = false;
  @observable receiptLink: string | null = null;
  @observable receiptId: string | null = null;
  @observable isReceiptCanceled = false;

  @action async postPeIncomeRequest(body: any) {
    this.isFetching = true;
    try {
      const { data } = await services.external.postPeIncomeRequest(body);
      if (data && data.receipt_link) {
        this.receiptLink = data.receipt_link;
        this.receiptId = data.id;
      }
      setTimeout(() => {
        this.refreshImage();
      }, 2000);
    } catch (e: any) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }

  @action async postPeCancelReceiptRequest(body: any) {
    this.isFetching = true;
    try {
      const { data } = await services.external.postPeCancelReceiptRequest(body);
      this.isReceiptCanceled = true;
      this.refreshImage();
    } catch (e: any) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }

  @action refreshImage() {
    if (this.receiptLink) {
      if (this.receiptLink.includes('?t=')) {
        const link = this.receiptLink.split('?t=')[0];
        this.receiptLink = link + '?t=' + Date.now();
      } else {
        this.receiptLink = this.receiptLink + '?t=' + Date.now();
      }
    }
  }

  @action reset() {
    this.isFetching = false;
    this.receiptLink = null;
  }
}
